import React from "react";
import { Box, IconButton, TextField, Tooltip, Zoom } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import { withTranslation } from 'react-i18next';

const Inner = ({ changeSearchFilter, t }) => {
    const [showFilter, setShowFilter] = React.useState(false);
    const [search, setSearch] = React.useState("");

    function handleShowFilter() {
        setShowFilter(!showFilter);
    }

    function handleSearch(event) {
        const { value } = event.target;
        setSearch(value);
        changeSearchFilter(value);
    }

    return (
        <Box display="flex" justifyContent="end" alignItems="center">
            <Zoom in={showFilter}>
                <TextField
                    variant="outlined"
                    size="small"
                    label={t('flashboard.filter.searchLabel')}
                    style={{ width: 400 }}
                    value={search}
                    onChange={handleSearch}
                />
            </Zoom>
            <Tooltip title={t('flashboard.filter.tooltip')}>
                <IconButton
                    style={{ marginLeft: 10 }}
                    onClick={handleShowFilter}
                >
                    <SearchIcon color={showFilter ? "success" : "inherit"} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default withTranslation()(React.memo(Inner));
